// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","displayLink":"_2Sx-3y3ab-ZyIr2VWeiWpq","shareLinkButtonContainer":"_25Tz96HWUW5XnjuYAN7YFW"};